<template>
  <div class="app-container">
    <div id="app" ref="appContainer" class="app-content">
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive" />
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted() {
    this.resizeHandler();
    window.addEventListener('resize', this.resizeHandler);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resizeHandler);
  },
  methods: {
    resizeHandler() {
      const appContainer = this.$refs.appContainer;
      if (!appContainer) return;

      const screenWidth = window.innerWidth;
      const maxWidth = 1024;

      // 移除所有缩放，添加1024宽度适配
      if (screenWidth > maxWidth) {
        // 当屏幕宽度大于1024px时，固定宽度为1024px，居中显示
        appContainer.style.width = `${maxWidth}px`;
        appContainer.style.margin = '0 auto';
        appContainer.style.height = 'auto';
        appContainer.style.overflow = 'auto';
      } else {
        // 当屏幕宽度小于等于1024px时，占满屏幕
        appContainer.style.width = '100%';
        appContainer.style.margin = '0';
        appContainer.style.height = 'auto';
        appContainer.style.overflow = 'auto';
      }
      
      // 确保body样式正确
      // document.body.style.overflow = 'hidden';
      document.body.style.height = '100vh';
      document.body.style.margin = '0';
      document.body.style.padding = '0';
    }
  }
}
</script>

<style>
html,
body {
  margin: 0;
  padding: 0;
  color: #2c3e50;
}

/* 最外层居中容器 */
.app-container {
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  /* overflow: hidden; */
}

/* 内容层：无 transform → fixed 正常！ */
.app-content {
  width: 100%;
  max-width: 1024px;
  min-height: 100vh;
  position: relative;
  background: #fff;
  transition: all 0.3s ease;
}

#app * {
  /* box-sizing: border-box; */
}

/* =================================== */
/* PC 端 >1024px 样式 */
/* =================================== */
@media (min-width: 1020px) {
  html,
  body {
    background: #000;
    /* overflow: hidden; */
  }
  .app-content {
    background: #fff;
    overflow: auto;
  }
  .app-container {
    height: 160vh;
    background: #fff;
  }
}
</style>